var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.853 13.977c-.078.078-.078.117-.078.195v4.453H2.025V4.875h9.453c.078 0 .117 0 .195-.078l1.25-1.25c.079-.078.118-.195.079-.352-.079-.117-.157-.195-.274-.195H2.025c-.547 0-.977.195-1.328.547-.39.39-.547.82-.547 1.328v13.75c0 .547.156.977.547 1.328.351.39.781.547 1.328.547h13.75a1.77 1.77 0 0 0 1.328-.547c.352-.351.547-.781.547-1.328v-5.664c0-.156-.078-.234-.195-.313-.157-.039-.274 0-.352.079l-1.25 1.25Zm6.133-7.891c.43-.43.664-.977.664-1.602 0-.625-.234-1.171-.664-1.64l-1.68-1.68C19.837.734 19.291.5 18.666.5s-1.172.234-1.602.664L6.791 11.438 6.4 14.953c-.078.547.078.977.469 1.328.351.39.781.547 1.328.469l3.516-.39L21.986 6.085Zm-3.867 1.21-7.266 7.266-2.539.274.274-2.54 7.265-7.265 2.266 2.266Zm2.539-3.124a.444.444 0 0 1 .117.312c0 .118-.04.196-.117.274l-1.211 1.21-2.266-2.265 1.211-1.21a.354.354 0 0 1 .274-.118c.117 0 .234.04.312.117l1.68 1.68Z",
    fill: "var(--default-text-color)"
  })));
};

export default SvgEdit;